// extracted by mini-css-extract-plugin
export default {"card":"DataSectionCard_card__MlD0g","flex":"DataSectionCard_flex__UXetp","dataSectionCard":"DataSectionCard_dataSectionCard__Kv6Iy"};